import {  AjaxObservable, AjaxCreationMethod  } from '/druid/AjaxObservable';

export const ajax: AjaxCreationMethod = AjaxObservable.create;